<template>
  <div id="_2022_5">
    <div id="Call-for-Nominations">
      <h3>
        <strong class="home-h"
          >IGU MGCS participated in the 35th International Geographical Congress
          (IGC 2024)
        </strong>
      </h3>
      <hr />
      <p>
        The International Geographical Union’s 35th International Geographical
        Congress (IGC) was held in Dublin, Ireland from August 24th to 30th.
        During this Congress, Modeling Geographical Systems Commission (MGSC) of
        IGU organized a parallel session–Modeling and Simulating Geographical
        Systems in the Big Data Era–to promote idea exchange and achievement
        sharing in this field. 6 experts and scholars attended this session and
        gave presentations. Several topics, including climate econometrics
        model, human–natural system modeling, urban air temperature simulation,
        the geography of flows, collaborative geographic simulation, and data
        sharing for geographic modeling, were discussed by attendees.
      </p>
      <p>
        To further support this collaborative approach, there is a pressing need
        for an open geographical modeling and simulation framework. Such a
        framework would serve as a catalyst, attracting more scholars and
        encouraging their collective efforts to address geographic challenges.
        This 3rd International Workshop on Geographic Modeling and Simulation is
        meticulously designed to explore pertinent theories, approaches, and
        potential applications, while fostering communication among experts from
        diverse domains. Its primary objectives include stimulating extensive
        discussions regarding the potential directions of the field and
        promoting further research, thus paving the way for a promising future
        in collaborative geographic modeling and simulation.
      </p>
      <div class="pic">
        <img
          style="width: 35%"
          src="../../../assets/static/img/Events/Geographical Congress1.png"
        />
        <img
          style="width: 35%; margin-left: 2.5%"
          src="../../../assets/static/img/Events/Geographical Congress2.png"
        />
      </div>
      <p>
        In addition, the IGU Executive Committee has organized a roundtable
        during the IGC Dublin 2024 on the topic: Geography and Artificial
        Intelligence in the IGU. The chair of IGU MGCS, Prof. Min Chen also
        attended the roundtable and called for mutual balancing between the two
        disciplines and improving cross-disciplinary collaboration.
      </p>
      <div class="pic">
        <img
          style="width: 50%"
          src="../../../assets/static/img/Events/Geographical Congress3.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '_2024_1'
};
</script>
<style scoped lang="less">
#_2022_5 {
  height: fit-content;
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 0 auto;
  position: relative;
  word-spacing: 0.3rem;
  margin-top: 2.2rem;
  line-height: 2rem;
  text-align: justify;
}

h3 {
  color: #1a80b6;
  font-size: 1.3rem;
  font-weight: 1000;
}

h4 {
  margin-top: 0.9rem;
  margin-bottom: 0.9rem;
}

.home-date {
  font-weight: bold;
  color: grey;
}

a {
  text-decoration: none;
}

.pic {
  // display: table-cell;
  text-align: center;
  // height: 128px;
  // width: 128px;
  overflow: hidden;
}
.flex {
  display: flex;
  // justify-content: center;
}
</style>
